import { render, staticRenderFns } from "./handleType.vue?vue&type=template&id=13752da2&scoped=true"
import script from "./handleType.vue?vue&type=script&lang=js"
export * from "./handleType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13752da2",
  null
  
)

export default component.exports